export default __webpack_public_path__ + "static/media/moneyBag0.51ba05a1.svg";